import React, { memo } from 'react';
import { HelpCircle, Play, Edit, X } from 'lucide-react';

// 🚀 메모이제이션된 퀴즈 카드 컴포넌트 (성능 최적화)
const QuizCard = memo(({ 
  quiz, 
  onEdit, 
  onDelete, 
  onPlay 
}) => {
  return (
    <div
      className="quiz-card"
      style={{
        position: 'relative',
        backgroundColor: 'white',
        border: '1px solid var(--gray-200)',
        borderRadius: 'var(--radius-lg)',
        padding: 'clamp(var(--spacing-md), 4vw, var(--spacing-lg))',
        transition: 'all 0.2s ease',
        cursor: 'default',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        minHeight: '180px',
        display: 'flex',
        flexDirection: 'column'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginBottom: 'var(--spacing-md)'
      }}>
        <div style={{ flex: 1 }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'flex-start', 
            justifyContent: 'space-between', 
            marginBottom: 'var(--spacing-xs)' 
          }}>
            <h3 style={{
              fontSize: 'var(--font-xl)',
              fontWeight: 600,
              color: 'var(--gray-800)',
              margin: 0,
              lineHeight: 1.3,
              flex: 1
            }}>
              {quiz.title}
            </h3>
          </div>
          <p style={{
            fontSize: 'var(--font-sm)',
            color: 'var(--gray-500)',
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--spacing-xs)'
          }}>
            <HelpCircle size={14} />
            {quiz.questions?.length || 0}문제 {quiz.meta?.subject ? `· ${quiz.meta.subject}` : ''}
          </p>
        </div>
      </div>
      
      {/* 하단 액션: 시작 / 수정 / 삭제 */}
      <div 
        onClick={(e) => { 
          e.stopPropagation(); 
        }}
        style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginTop: 'auto',
          paddingTop: 'var(--spacing-md)',
          borderTop: '1px solid var(--gray-100)'
        }}
      >
        <button
          className="btn-primary"
          onClick={(e) => { 
            e.stopPropagation(); 
            onPlay(); 
          }}
          style={{
            fontSize: 'var(--font-base)',
            fontWeight: 600,
            padding: 'var(--spacing-sm) var(--spacing-md)',
            minHeight: '44px',
            width: 'auto',
            minWidth: '80px',
            maxWidth: '120px',
            flexShrink: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--spacing-xs)',
            borderRadius: 'var(--radius-md)',
            transition: 'all 0.2s ease'
          }}
        >
          <Play size={18} />
          시작
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-xs)' }}>
          {onEdit && (
            <button 
              className="btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
              style={{ 
                padding: 'var(--spacing-xs)',
                minHeight: '36px',
                minWidth: '36px',
                width: '36px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 'var(--radius-md)',
                color: 'var(--gray-600)',
                transition: 'all 0.2s ease'
              }}
            >
              <Edit size={16} />
            </button>
          )}
          <button 
            className="btn-danger"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(quiz.id);
            }}
            style={{ 
              padding: 'var(--spacing-xs)',
              minHeight: '36px',
              minWidth: '36px',
              width: '36px',
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--font-base)',
              fontWeight: 600,
              transition: 'all 0.2s ease'
            }}
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
});

QuizCard.displayName = 'QuizCard';

export default QuizCard;
